import { Auth } from '@hub-la/fe-core-auth';
import { HttpClient, HttpStatusCode } from '@hub-la/fe-core-http-client';
import axios from 'axios';
import { injectable } from 'inversify';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

let AxiosHttpClient = class AxiosHttpClient extends HttpClient {
  constructor(auth) {
    super();
    this.auth = auth;
  }
  request(data) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      let axiosResponse;
      /**
       * @todo Token is being inject here but, ideally, we have to move this out of HttpClient
       */
      const token = yield this.auth.getToken();
      if (token) {
        data.headers = Object.assign({}, {
          authorization: `Bearer ${token}`
        });
      }
      let isTimeout = false;
      try {
        axiosResponse = yield axios.request({
          url: data.url,
          method: data.method,
          data: data.body,
          params: data.params,
          headers: data.headers,
          onUploadProgress: data.onUploadProgress,
          withCredentials: data.withCredentials,
          signal: data.signal,
          responseType: data.responseType,
          timeout: data.timeout
        });
      } catch (error) {
        console.error(error);
        axiosResponse = error.response;
        if (error instanceof Error) {
          isTimeout = (_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('timeout');
        }
        if (!axiosResponse) {
          axiosResponse = {
            data: error === null || error === void 0 ? void 0 : error.message
          };
        }
      }
      return {
        statusCode: (_b = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.status) !== null && _b !== void 0 ? _b : isTimeout ? HttpStatusCode.GATEWAY_TIMEOUT : undefined,
        data: axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data,
        headers: axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.headers
      };
    });
  }
};
AxiosHttpClient = __decorate([injectable(), __metadata("design:paramtypes", [Auth])], AxiosHttpClient);

export { AxiosHttpClient };
